<template>
  <div class="flex flex-col justify-start items-center">
    <div class="w-full">
      <h1>Privacy Policy</h1>
      <p>
        By using this site, you agree to the Privacy Policy of this website and
        associated directory (“the Site”).
      </p>

      <p>
        The Privacy Policy relates to the collection and use of personal
        information you may supply to us through your completion of an article
        or directory listing.
      </p>

      <p>
        We reserve the right, at our discretion, to modify or remove portions of
        this Privacy Policy at any time. This Privacy Policy is in addition to
        any other terms and conditions applicable to the website.
      </p>

      <p>
        We take your privacy seriously and we recognise the importance of
        protecting the privacy of information collected through the directory,
        in particular information that is capable of identifying an individual
        (“personal information”).
      </p>

      <h3>Personal Information</h3>
      <p>
        Personal information about visitors to our site is collected only when
        knowingly and voluntarily submitted. For example, we may need to collect
        such information to provide you with further services or to answer or
        forward any requests or enquiries. It is our intention that this policy
        will protect your personal information from being dealt with in any way
        that is consistent with applicable privacy laws in New Zealand.
      </p>

      <h3>Use of Information</h3>
      <p>
        Personal information that visitors submit to our site is used only for
        the purpose for which it is submitted or for such other secondary
        purposes that are related to the primary purpose, unless we disclose
        other uses in this Privacy Policy or at the time of collection.
      </p>

      <h3>Disclosure</h3>
      <p>
        Apart from where you have consented or disclosure is necessary to
        achieve the purpose for which it was submitted, personal information may
        be disclosed in special situations where we have reason to believe that
        doing so is necessary to identify, contact or bring legal action against
        anyone damaging, injuring, or interfering (intentionally or
        unintentionally) with our rights or property, users, or anyone else who
        could be harmed by such activities. Also, we may disclose personal
        information when we believe in good faith that the law requires
        disclosure. In the event that you contact us to request further
        assistance, we may engage third parties to provide you with goods or
        services on our behalf. If this is the case, we may disclose your
        personal information – with your full consent – to those third parties
        in order to meet your request for goods or services.
      </p>

      <h3>Security</h3>
      <p>
        We strive to ensure the security, integrity and privacy of personal
        information submitted to our sites, and we review and update our
        security measures in light of current technologies. Unfortunately, no
        data transmission over the Internet can be guaranteed to be totally
        secure.
      </p>
      <p>
        However, we will endeavour to take all reasonable steps to protect the
        personal information you may transmit to us or from our online products
        and services. Once we do receive your transmission, we will also make
        our best efforts to ensure its security on our systems.
      </p>

      <p>
        In addition, our employees and the contractors who provide services
        related to our information systems are obliged to respect the
        confidentiality of any personal information held by us. However, we will
        not be held responsible for events arising from unauthorised access to
        your personal information.
      </p>

      <h3>Collecting Information for Users</h3>

      <h5>IP Addresses</h5>

      <p>
        Our web servers gather your IP address to assist with the diagnosis of
        problems or support issues with our services. Again, information is
        gathered in aggregate only and cannot be traced to an individual user.
      </p>

      <h5>Cookies and Applets</h5>
      <p>
        We use cookies to provide you with a better experience. These cookies
        and allow us to increase your security by storing your session ID and
        are a way of monitoring single user access. This aggregate, non-personal
        information is collated and provided to us to assist in analysing the
        usage of the site.
      </p>

      <h5>Access to Information</h5>
      <p>
        We will endeavour to take all reasonable steps to keep secure any
        information which we hold about you, and to keep this information
        accurate and up to date. If, at any time, you discover that information
        held about you is incorrect, you may contact us to have the information
        corrected.
      </p>

      <h5>Problems or questions</h5>

      <p>
        If we become aware of any ongoing concerns or problems with our
        websites, we will take these issues seriously and work to address these
        concerns. If you have any further queries relating to our Privacy
        Policy, or you have a problem or complaint, please email support@hail.to
        We may revise these Terms of Use at any time. Any such revisions will
        take effect once notified through a notice at the end of these Terms of
        use detailing the respect(s) in which the Terms have changed. We may
        also elect to place such notice on the Site’s homepage.
      </p>

      <h3>Disclaimer</h3>

      <p>
        The NZ Careers Expo site provides features that link you or provide
        content from other websites. Whilst we will use our reasonable
        endeavours to maintain content we are not responsible for the currency
        or accuracy of content on or from such sites.
      </p>
      <p>
        Hail Limited disclaims and excludes all liability for any claim, loss,
        demand or damages of any kind (including for negligence) arising out of
        or in connection with the use of either this website, the directory or
        the information, content or materials included on this site or on any
        website to which it is linked.
      </p>
      <p>
        The inclusion of a link to a third party sites does not imply any
        endorsement of the linked website or its content or provider.
      </p>
      <p>
        These terms and conditions and privacy policy were reviewed October
        2019.
      </p>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
p {
  margin: 10px 0;
}
</style>
